import React, { FunctionComponent } from 'react';
import { Box, Typography, useTheme, CircularProgress } from '@material-ui/core';
import usePlatformConfig from '../../../../../common/react/usePlatformConfig';
import SimpleButton from '../../../../../common/components/presentation/simpleButton/SimpleButton';
import { IButtonProps } from '../ActionButtons';
import actionButtonsStyles from '../ActionButtonsStyles';
import Translation from '../../../../../common/components/translation/Translation';
import { ISpcTheme } from '../../../../../common/theme/ISpcTheme';
import useCustomizeCarContext from '../../../../hooks/useCustomizeCarContext';

type ISubmitProps = IButtonProps & { disabled: boolean; loading?: boolean };

const Submit: FunctionComponent<ISubmitProps> = ({ onClick, disabled, loading }) => {
  const styles = actionButtonsStyles();
  const {
    platformConfig: { isCheckout4Enabled },
  } = usePlatformConfig();
  const {
    spc: {
      customise: { displayVehicleNameWithReserveOnlineCTA },
    },
  } = useTheme<ISpcTheme>();
  const { selectedCar } = useCustomizeCarContext();

  return (
    <Box className={styles.item}>
      {!isCheckout4Enabled && (
        <SimpleButton
          buttonClassName={styles.submitButton}
          type={'filled'}
          dataTest="customise:summary:submit"
          action={onClick}
          disabled={disabled}
        >
          <Typography variant="caption" className={styles.submitButtonLabel}>
            {loading && <CircularProgress size={15} className={styles.circularProgress} />}
            <Translation id={'trans__configurator__customise_page_ctas__order_online_cta'} />
            {displayVehicleNameWithReserveOnlineCTA && selectedCar?.car.attributes.vehicleDisplayName}
          </Typography>
        </SimpleButton>
      )}
    </Box>
  );
};

export default Submit;
